/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-28 19:39:09
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-25 14:50:48
 * @FilePath: \baishu_react_ui\src\components\BsyDialog\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'

import Dlg from './dlg'
import { BsyUtils } from '../../utils/Utils'


const BsyDialogBgFull = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        let rootTokenClass = 'rootTokenCls' + (new Date()).getTime();
        holder = document.createElement('div');
        holder.style.zIndex = window.FX.STATIC.zIndex++;
        holder.classList.add("bsy-x-window-mask-full");
        holder.onclick = function (event) {
            if (window.$(event.target).hasClass('bsy-x-window-mask-full')) {
                event.preventDefault();
                let ok = props.coloseModel()
                console.log(ok)
                if(props.coloseModel()){
                    CleanRootNode();
                }
            }

        }
        holder.classList.add("scrollable"); //某些情况下，窗口高度不够，不会出滚动条，无法操作
        setTimeout(() => {
            holder.classList.add("modal");
         
        }, 30)
        holder.classList.add('rootTokenClass');
        if (props.customCls)
            holder.classList.add(props.customCls);


        document.body.appendChild(holder)

        let CleanRootNode = (e) => {
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己 
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
                holder.classList.add("fadeout");
                holder.classList.remove("fadein");
                setTimeout(() => {
                    ReactDOM.unmountComponentAtNode(holder)
                    holder.remove();
                    document.removeEventListener('mouseup', CleanRootNode, false);
                }, 218)
            }
        }
        // document.addEventListener('mouseup', CleanRootNode, false);

        const newProps = { ...props }
        newProps.onRemoveRoot = () => {
            //自动清理
            CleanRootNode();
        }

        ReactDOM.render(
            <Dlg
                {...newProps}
            />,
            holder
        )
    }).catch(res => {
        console.error('BsyDialog', res);
    })
export default BsyDialogBgFull